import React from 'react';
import { MARKETING_LESSON_VIDEO_URL } from './marketingDemoData';
import './MarketingAssets.css';

function toVimeoEmbedUrl(url) {
    if (!url) {
        return MARKETING_LESSON_VIDEO_URL;
    }
    if (url.includes('player.vimeo.com')) {
        return url.split('?')[0];
    }
    const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match
        ? `https://player.vimeo.com/video/${match[1]}`
        : MARKETING_LESSON_VIDEO_URL;
}

/** Real V1 lesson Vimeo embed for marketing captures. */
const MarketingVideoPlayer = ({
    url = MARKETING_LESSON_VIDEO_URL,
    title = 'Oola Framework — lesson preview',
    className = '',
}) => {
    const embedBase = toVimeoEmbedUrl(url);
    const embedSrc = `${embedBase}?title=0&byline=0&portrait=0`;

    return (
        <div className={`marketing-video-player ${className}`.trim()}>
            <iframe
                title={title}
                src={embedSrc}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
            />
        </div>
    );
};

export default MarketingVideoPlayer;
